export const PaymentScheduleTestIds = {
  PREV_BUTTON: 'payment-schedule.prev-button',
  NEXT_BUTTON: 'payment-schedule.next-button',
};
